import React, { useState } from "react";
import { Link } from "react-router-dom";
import section2img from "../assests/HomeImg/section2-img.svg";
import AnimatedCounter from "../Shared/AnimatedCounter";

// Import sequence icons
import DiclosureunderregulationImg from "../assests/InvestorsImages/squence/leadership-1.png";
import StockExchangeCorrespondenceImg from "../assests/InvestorsImages/squence/disclosure.webp";
import financialImg from "../assests/InvestorsImages/squence/financial.webp";
import policiesImg from "../assests/InvestorsImages/squence/policies.webp";
import investorImg from "../assests/InvestorsImages/squence/investor.webp";
import sherholderImg from "../assests/InvestorsImages/squence/sherholder.webp";
import boardImg from "../assests/InvestorsImages/squence/board.webp";
import compositeImg from "../assests/InvestorsImages/squence/composite.webp";

import "./index.css";

// ── SVG Icons ────────────────────────────────────────────────────────────────
const DownloadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.66797 6.66666L8.0013 9.99999L11.3346 6.66666" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 10V2" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ArrowRightIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M2.91797 7H11.0846" stroke="currentColor" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 2.91666L11.0833 6.99999L7 11.0833" stroke="currentColor" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ChartIcon = () => (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
);

const FileIcon = () => (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
);

const ShieldIcon = () => (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
);

const TrendingUpIcon = () => (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
    </svg>
);

const GlobeIcon = () => (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const BriefcaseIcon = () => (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
);

const LeafIcon = () => (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
);

// ── Tab config ─────────────────────────────────────────────────────────────────
const TABS = [
    { label: "Investor Overview", id: "investor-overview", icon: <ChartIcon /> },
    { label: "Financial Results", id: "financial-results", icon: <TrendingUpIcon /> },
    { label: "Annual Reports", id: "annual-reports", icon: <FileIcon /> },
    { label: "Governance", id: "governance", icon: <ShieldIcon /> },
    { label: "Stock Information", id: "stock-information", icon: <GlobeIcon /> },
    { label: "Disclosures", id: "disclosures", icon: <BriefcaseIcon /> },
    { label: "ESG", id: "esg", icon: <LeafIcon /> },
];

// ── Hero stats ─────────────────────────────────────────────────────────────────
const HERO_STATS = [
    { val: "$350 Mn", lab: "Revenue" },
    { val: "150+", lab: "Countries Served" },
    { val: "16", lab: "Manufacturing Sites" },
    { val: "10", lab: "USFDA Approved Units" },
    { val: "190+", lab: "Patents Filed" },
    { val: "3000+", lab: "Employees" },
];

// ══════════════════════════════════════════════════════════════════════════════
// FINANCIAL PERFORMANCE SECTION
// ══════════════════════════════════════════════════════════════════════════════
const FIN_TABS = ["Quarterly Results", "Annual Financials", "Investor Presentation Archive"];

const QUARTERLY_DATA = [
    { period: "Q3 FY25 (Placeholder)", revenue: "\u20B9580 Cr", ebitda: "\u20B9105 Cr", netProfit: "\u20B962 Cr", margin: "18.1%" },
    { period: "Q2 FY25 (Placeholder)", revenue: "\u20B9562 Cr", ebitda: "\u20B998 Cr", netProfit: "\u20B955 Cr", margin: "17.4%" },
    { period: "Q1 FY25 (Placeholder)", revenue: "\u20B9545 Cr", ebitda: "\u20B994 Cr", netProfit: "\u20B951 Cr", margin: "17.2%" },
    { period: "Q4 FY24 (Placeholder)", revenue: "\u20B9528 Cr", ebitda: "\u20B990 Cr", netProfit: "\u20B948 Cr", margin: "17.0%" },
];

const FinancialPerformanceSection = () => {
    const [activeFinTab, setActiveFinTab] = useState(0);
    return (
        <section id="financial-results" className="inv-fin">
            {/* Header */}
            <div className="inv-fin__header">
                <h2 className="inv-fin__title">Financial Performance</h2>
                <img src={section2img} alt="Decorative" className="home-section2-image" />
                <p className="inv-fin__subtitle">Structured financial disclosures updated each quarter</p>
            </div>

            {/* Tab Switcher */}
            <div className="inv-fin__tabs-wrap">
                <div className="inv-fin__tabs">
                    {FIN_TABS.map((t, i) => (
                        <button
                            key={i}
                            className={`inv-fin__tab${activeFinTab === i ? " inv-fin__tab--active" : ""}`}
                            onClick={() => setActiveFinTab(i)}
                        >
                            {t}
                        </button>
                    ))}
                </div>
            </div>

            {/* Placeholder alert */}
            <div className="inv-fin__alert">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                    <path d="M8.00065 14.6667C11.6825 14.6667 14.6673 11.6819 14.6673 8.00004C14.6673 4.31814 11.6825 1.33337 8.00065 1.33337C4.31875 1.33337 1.33398 4.31814 1.33398 8.00004C1.33398 11.6819 4.31875 14.6667 8.00065 14.6667Z" stroke="#E17100" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M8 10.6667V8" stroke="#E17100" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M8 5.33337H8.00667" stroke="#E17100" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>
                    <strong>Placeholder Data Only.</strong> Detailed audited financial statements will be available upon
                    publication following SEBI filing requirements. All figures are indicative estimates for illustration purposes.
                </span>
            </div>

            {/* Table */}
            <div className="inv-fin__table-wrap">
                <table className="inv-fin__table">
                    <thead>
                        <tr>
                            <th>Period</th>
                            <th>Revenue</th>
                            <th>EBITDA</th>
                            <th>Net Profit</th>
                            <th>EBITDA Margin</th>
                            <th>Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        {QUARTERLY_DATA.map((row, i) => (
                            <tr key={i}>
                                <td className="inv-fin__td-period">{row.period}</td>
                                <td>{row.revenue}</td>
                                <td>{row.ebitda}</td>
                                <td>{row.netProfit}</td>
                                <td>
                                    <span className="inv-fin__badge">{row.margin}</span>
                                </td>
                                <td>
                                    <button className="inv-fin__pdf-btn">
                                        <DownloadIcon />
                                        PDF
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
};

// ══════════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ══════════════════════════════════════════════════════════════════════════════
const Investors = () => {
    const [activeTab, setActiveTab] = useState(0);

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <div className="investors-wrapper">

            {/* ══ HERO ══ */}
            <section className="investors-hero">
                <div className="investors-hero__content">
                    <h1 className="investors-hero__title">Investor Relations</h1>
                    <p className="investors-hero__subtitle">
                        Driving Long-Term Value Through Integrated Growth and Global Leadership
                    </p>

                    {/* CTA Buttons */}
                    {/* <div className="investors-hero__cta-row">
                        <a
                            href="#investor-overview"
                            className="investors-hero__cta investors-hero__cta--presentation"
                            onClick={(e) => { e.preventDefault(); setActiveTab(0); scrollTo("investor-overview"); }}
                        >
                            <DownloadIcon />
                            Investor Presentation
                            <ArrowRightIcon />
                        </a>
                        <a
                            href="#investor-overview"
                            className="investors-hero__cta investors-hero__cta--profile"
                            onClick={(e) => { e.preventDefault(); setActiveTab(0); scrollTo("investor-overview"); }}
                        >
                            <DownloadIcon />
                            Corporate Profile
                        </a>
                    </div> */}

                    {/* Stats bar */}
                    <div className="investors-hero__stats">
                        {HERO_STATS.map((s) => (
                            <div key={s.lab} className="investors-hero__stat-card">
                                <div className="investors-hero__stat-value">
                                    <AnimatedCounter value={s.val} />
                                </div>
                                <div className="investors-hero__stat-label">{s.lab}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ══ BREADCRUMB ══ */}
            <div className="cdmo-breadcrumb-container">
                <div className="cdmo-breadcrumb-wrapper">
                    <Link to="/" className="cdmo-breadcrumb-link cdmo-home-link">
                        <svg className="cdmo-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14"
                                stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"
                            />
                            <path
                                d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z"
                                stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"
                            />
                        </svg>
                        Home
                    </Link>
                    <span className="cdmo-breadcrumb-separator">›</span>
                    <span className="cdmo-breadcrumb-current">Investors</span>
                </div>
            </div>

            {/* ══ STICKY TABS ══ */}
            {/* <div className="investors-tabs">
                {TABS.map((tab, i) => (
                    <button
                        key={tab.id}
                        onClick={() => { setActiveTab(i); scrollTo(tab.id); }}
                        className={`investors-tabs__button${activeTab === i ? " investors-tabs__button--active" : ""}`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div> */}

            {/* ══ SECTION ANCHORS — real content will be added section by section ══ */}


            {/* ══ COMPANY AT A GLANCE ══ */}
            <section id="investor-overview" className="inv-glance">
                <div className="inv-glance__header">
                    <h2 className="inv-glance__title">Company at a Glance</h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p className="inv-glance__desc">
                        Viyash Scientific Limited is a fully backward integrated pharmaceutical enterprise operating
                        across Human and Animal Health segments. With diversified revenue streams across API,
                        CDMO, and Formulations businesses, Viyash serves <strong>150+ countries</strong> with a portfolio of{" "}
                        <strong>75+ commercial Human APIs</strong> and <strong>30+ Vet APIs</strong>.
                    </p>
                </div>

                <div className="inv-glance__body">
                    {/* Left – bullet list + button */}
                    <div className="inv-glance__left">
                        <ul className="inv-glance__list">
                            {[
                                "1,000+ registrations across 12 dosage forms",
                                "250+ global customers across 150+ countries",
                                "60+ commercial export products",
                                "Leading presence in Spain, Turkey, Brazil, Benelux & India",
                                ">85% backward integration across value chain",
                                "75+ commercial Human APIs · 30+ Vet APIs",
                            ].map((item, i) => (
                                <li key={i} className="inv-glance__list-item">
                                    <span className="inv-glance__dot-outer">
                                        <span className="inv-glance__dot-inner" />
                                    </span>
                                    <span className="inv-glance__list-text">{item}</span>
                                </li>
                            ))}
                        </ul>
                        {/* <button className="inv-glance__btn">
                            <DownloadIcon />
                            Download Investor Deck
                            <ArrowRightIcon />
                        </button> */}
                    </div>

                    {/* Right – 2×2 metric cards */}
                    <div className="inv-glance__metrics">
                        {[
                            { val: "$350 Mn", label: "Revenue", sub: "USD FY25E", color: "#003D7A" },
                            { val: "150+", label: "Countries", sub: "Global Markets", color: "#005FAD" },
                            { val: "250+", label: "Customers", sub: "Global Customers", color: "#00A651" },
                            { val: "1000+", label: "Registrations", sub: "Across 12 Dosage Forms", color: "#006B3C" },
                        ].map((m, i) => (
                            <div key={i} className="inv-glance__metric-card">
                                <div className="inv-glance__metric-val" style={{ color: m.color }}>
                                    <AnimatedCounter value={m.val} />
                                </div>
                                <div className="inv-glance__metric-label">{m.label}</div>
                                <div className="inv-glance__metric-sub">{m.sub}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ══ INVESTORS LINKS SECTION (Sequent) ══ */}
            <section className="inv-links-sec">
                <div className="inv-glance__header">
                    <h2 className="inv-glance__title">Investors</h2>
                    <img src={section2img} alt="Decorative Line" className="home-section2-image" />
                    {/* <p className="inv-glance__desc">
                        Sequent Scientific Limited is India’s leading animal health company.
                    </p> */}
                </div>

                <div className="inv-links-grid">
                    {[
                        { title: "Diclosure under regulation 46", img: DiclosureunderregulationImg, url: "/diclosure-under-regulation" },
                        { title: "Stock Exchange Correspondence", img: StockExchangeCorrespondenceImg, url: "/stock-exchange-correspondence" },
                        { title: "Financials", img: financialImg, url: "/financial" },
                        { title: "Annual reports ", img: policiesImg, url: "/annual-reports" },
                        { title: "Corporate Governance", img: boardImg, url: "/CorporateGovernance" },
                        { title: "Shareholder Information", img: sherholderImg, url: "/shareholder-information" },
                        { title: "Investor Contacts", img: investorImg, url: "/investor-contacts" },
                        { title: "Composite Scheme of Arrangement", img: compositeImg, url: "/composite-scheme" },
                    ].map((item, idx) => {
                        const isInternal = item.url.startsWith("/");
                        if (isInternal) {
                            return (
                                <Link to={item.url} key={idx} className="inv-link-card">
                                    <div className="inv-link-card__icon-wrap">
                                        <img src={item.img} alt={item.title} className="inv-link-card__img" />
                                    </div>
                                    <div className="inv-link-card__content">
                                        <h3 className="inv-link-card__title">{item.title}</h3>
                                        <span className="inv-link-card__btn">
                                            Explore <ArrowRightIcon />
                                        </span>
                                    </div>
                                </Link>
                            );
                        }
                        return (
                            <a href={item.url} target="_blank" rel="noopener noreferrer" key={idx} className="inv-link-card">
                                <div className="inv-link-card__icon-wrap">
                                    <img src={item.img} alt={item.title} className="inv-link-card__img" />
                                </div>
                                <div className="inv-link-card__content">
                                    <h3 className="inv-link-card__title">{item.title}</h3>
                                    <span className="inv-link-card__btn">
                                        Explore <ArrowRightIcon />
                                    </span>
                                </div>
                            </a>
                        );
                    })}

                </div>
            </section>
        </div>
    );
};

export default Investors;